// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-NpoypNI1tkH6D9Ot8SO4","list":"cu75tDr39060XvLiae2rA","item":"_1QuDLZLRkizPXxPxtvsbZ2","dot":"kA6FjBWZlPFYFUr85JvRL"};